import { queryOptions } from '@tanstack/react-query'
import { apiGet, apiPost } from './client'
import type { EmailTemplateRow, EmailTemplatesList, EmailTemplatesShell } from './settingsEaseedeskEmailTemplates'

export type MobileTemplateRow = EmailTemplateRow
export type MobileTemplatesList = EmailTemplatesList
export type MobileTemplatesShell = EmailTemplatesShell

/**
 * Settings → Easeedesk → Mobile templates.
 *
 * Perechile vechi: `settings/easeedesk/mobile_templates_settings`,
 * `get_mobile_templates_list`, `create_mobile_template`,
 * `update_mobile_template`, `remove_mobile_template`.
 *
 * Randul si scheletul au aceeasi forma ca la sabloanele de email - alt tabel,
 * alt drept, acelasi ecran - deci felurile lor se iau de acolo, nu se scriu a
 * doua oara.
 *
 * `apiGet` / `apiPost` pun ELE `/api/v2` in fata caii.
 */

export function mobileTemplatesShellQuery() {
  return queryOptions({
    queryKey: ['settings', 'easeedesk', 'mobile_templates'],
    queryFn: () => apiGet<MobileTemplatesShell>('/settings/easeedesk/mobile_templates'),
  })
}

export function mobileTemplatesListQuery() {
  return queryOptions({
    queryKey: ['settings', 'easeedesk', 'mobile_templates', 'list'],
    queryFn: () => apiGet<MobileTemplatesList>('/settings/easeedesk/mobile_templates/list'),
  })
}

export function createMobileTemplate(template_name: string, template_subject: string, template_body: string) {
  return apiPost<{ ok?: boolean; template?: { id: number; name: string } }>('/settings/easeedesk/mobile_templates', {
    template_name,
    template_subject,
    template_body,
  })
}

export function updateMobileTemplate(
  template: number,
  template_name: string,
  template_subject: string,
  template_body: string,
) {
  return apiPost<{ ok?: boolean }>(`/settings/easeedesk/mobile_templates/${template}`, {
    template_name,
    template_subject,
    template_body,
  })
}

export function removeMobileTemplate(template: number) {
  return apiPost<{ ok?: boolean }>(`/settings/easeedesk/mobile_templates/${template}/remove`, {})
}
